import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

const RecentlyViewedRoute = (
  <Route
    key="browsing_history"
    path="browsing_history"
    handle={{
      clientSide: true,
      pageViewEvent: {
        pageName: MParticlePageName.RecentlyViewed,
      },
    }}
    lazy={async () => ({
      Component: (await import(
        '../components/recently_viewed/recently_viewed_container'
      )).default,
    })}
  />
);

export default RecentlyViewedRoute;
